import { render } from "./CampaignValue.vue?vue&type=template&id=8b007d6c&scoped=true"
import script from "./CampaignValue.vue?vue&type=script&lang=js"
export * from "./CampaignValue.vue?vue&type=script&lang=js"

import "./CampaignValue.vue?vue&type=style&index=0&id=8b007d6c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b007d6c"]])

export default __exports__